import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FrameworkHelper } from '@brafton/angular-framework-library';
import { SearchHit } from '@brafton/atlas-api-client/lib/models/search.model';

@Component({
  selector: 'search-results-box',
  templateUrl: './search-results-box.component.html',
  styleUrls: ['./search-results-box.component.scss'],
  host: { class: 'search-results-box' },
})
export class SearchResultsBoxComponent {
  @Input() results?: SearchHit[];

  constructor(private frameworkHelper: FrameworkHelper, private router: Router) {}

  getHighLightTitle(result: any): string | undefined {
    if (!result) return;
    if (result?.highlight?.title) return result?.highlight?.title;
    return result?.title;
  }

  getHighLightContent(result: any): string | undefined {
    if (!result) return;

    if (result?.highlight?.text) {
      const arrayFlattened = result?.highlight?.text;
      const stringSliced = arrayFlattened.slice(0, 350);
      return stringSliced;
    }

    if (result?.source?.text) return result?.source?.text.slice(0, 50);
    return;
  }

  checkData(data: any) {
    return true;
  }

  getTitle(result: any): string | undefined {
    if (!result) return;
    const title = result.highlight?.title || result.title;

    return title;
  }
}
